import mealService from "@/services/meal";
import galleryService from "@/services/gallery";

export default {
    methods: {
        showQr(item) {
            // Access parent properties if available
            const target = this.$parent || this;
            target.selectedMealForQr = item;
            target.isQrDialogOpen = true;
        },

        print(food) {
            this.printMealCard(food);
        },

        forSale(item) {
            mealService
                .setDailyOffer(item)
                .then(() => {
                    const message = item.for_sale 
                        ? this.$t("meal_added_to_daily_offer") 
                        : this.$t("meal_removed_from_daily_offer");
                    this.showSuccessSnackbar(message);
                })
                .catch(() => {
                    this.showErrorSnackbar(this.$t("error_updating_daily_offer"));
                });
        },

        upload(item, event) {
            let data = new FormData();
            data.append("image", event ? event.target.files[0] : window.event.target.files[0]);
            data.append("food_id", item.id);
            galleryService
                .uploadGalleryImage(data)
                .then((res) => {
                    if (res.data) {
                        // Access parent's allMeals if available, otherwise use local meals
                        const mealsArray = this.$parent?.allMeals || this.allMeals || this.meals;
                        const meal = mealsArray.find((m) => m.id == item.id);
                        if (meal) {
                            meal.image_id = res.data.id;
                            meal.image = res.data;
                            // Call parent's filter method if it exists
                            if (this.$parent?.applyMealFilters) {
                                this.$parent.applyMealFilters();
                            }
                        }
                        this.showSuccessSnackbar(this.$t("image_uploaded"));
                    }
                })
                .catch(() => {
                    this.showErrorSnackbar(this.$t("error_adding_image"));
                });
        },

        removeImage(item) {
            mealService
                .deleteFoodImage(item.id)
                .then((res) => {
                    if (res.data) {
                        // Access parent's allMeals if available, otherwise use local meals
                        const mealsArray = this.$parent?.allMeals || this.allMeals || this.meals;
                        const meal = mealsArray.find((m) => m.id == item.id);
                        if (meal) {
                            meal.image_id = null;
                            meal.image = null;
                            // Call parent's filter method if it exists
                            if (this.$parent?.applyMealFilters) {
                                this.$parent.applyMealFilters();
                            }
                        }
                        this.showSuccessSnackbar(this.$t("image_deleted"));
                    }
                })
                .catch(() => {
                    this.showErrorSnackbar(this.$t("error_deleting_image"));
                });
        },
    },
};
